export default "__VITE_ASSET__BTM0sDwf__"